import {ref} from '@vue/reactivity'
import {ResponseData, Sorting} from '@/services/types'
import {AxiosError} from 'axios'
import {showError} from '@/composables/utils'
import {LimitPageDefault} from '@/composables/constants'
import {OrderByVariants} from '@/services/constants'
import CommentsService,{GetListParams as Params} from '@/services/CommentsService'
import {Comment} from '@/composables/comments/models'



type Meta = {
    limit: number,
    offset: number,
    sort_by: string,
    order_by: OrderByVariants,
    total: number,
    page: {
        current: number,
        total: number,
    },
}

enum SortByVariants {
    CREATED_AT = 'created_at'
}


const SortingVariants: Sorting[] = [
    {
        name: 'Сначала новые',
        sort_by: SortByVariants.CREATED_AT,
        order_by: OrderByVariants.DESC,
    },
    {
        name: 'Сначала старые',
        sort_by: SortByVariants.CREATED_AT,
        order_by: OrderByVariants.ASC,
    }
]

export const SortingDefault: Sorting = SortingVariants[0]

const MetaDefault = {
    limit: LimitPageDefault.value,
    offset: 0,
    order_by: SortingDefault.order_by,
    sort_by: SortingDefault.sort_by,
    total: 0,
    page: {
        current: 1,
        total: 1,
    }
} as Meta



export function list() {
    const list = ref([] as Comment[])
    const isLoading = ref(false)
    const filterAgentId = ref()
    const sorting = ref(SortingDefault)
    const meta = ref(MetaDefault)

    function fetch(): void {

        const params = {
            limit: meta.value.limit,
            offset: meta.value.offset,
            order_by: meta.value.order_by,
            sort_by: meta.value.sort_by,
            agent_id: filterAgentId.value,
        } as Params

        isLoading.value = true
        CommentsService.getList(params)
            .then((response: ResponseData) => {
                list.value = response.data.data.items
                meta.value = response.data.data.meta
            })
            .catch((e: AxiosError) => showError(e))
            .finally(() => isLoading.value = false)
    }

    function store(agentId: number, text: string){
        isLoading.value = true
        return CommentsService.store(agentId, text)
            .then((response: ResponseData) => {
                list.value.push(response.data.data)
            })
            .catch((e: AxiosError) => showError(e))
            .finally(() => isLoading.value = false)
    }

    function setPage(value: number) {
        meta.value.offset = (value - 1) * meta.value.limit
    }

    function setLimit(value: number) {
        meta.value.limit = value
    }

    function setSorting(value: Sorting) {
        sorting.value = value
        meta.value.sort_by = value.sort_by
        meta.value.order_by = value.order_by
    }

    function reset(){
        setFilterAgentId()
        setPage(1)
        setLimit(LimitPageDefault.value)
        setSorting(SortingDefault)
    }


    function setFilterAgentId(id?: null|number) {
        filterAgentId.value = id
    }


    return {
        // getters
        list,
        isLoading,
        meta,
        sorting,
        sortingVariants: SortingVariants,

        // mutations
        setFilterAgentId,
        setPage,
        setLimit,
        setSorting,
        reset,

        // actions
        fetch,
        store
    }
}
